import './App.css';
import Routes from "./routes";
import { connect } from "react-redux";
import { onReload } from './store/auth/actions'
import { onReloadAdmin } from './store/authAdmin/actions'

import { useEffect } from 'react';

function App({ onReload, onReloadAdmin, ...props }) {
    useEffect(() => {
        onReload()
    }, [onReload])

    useEffect(() => {
        if(process.env.REACT_APP_ENV === "production"){
            // console.log = ()    => {};
        }
        onReloadAdmin()
    }, [onReloadAdmin])

    // 
    return (
        <div className="App">
            {/* <div id="google_translate_element"></div> */}
            <Routes />
        </div>
    );
}

const mapStateToProps = (state) => ({
    state: state
})
const mapDispatchToProps = { onReload, onReloadAdmin }
export default connect(mapStateToProps, mapDispatchToProps)(App);
